<template>
  <div class="container mt-3">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button type="button" @click="runBackup" class="btn btn-primary">
          <i class="bi bi-layer-backward"></i>
          Backup
        </button>
      </div>
    </div>

    <!-- ✅ Message global -->
    <div v-if="result" class="mt-3">
      <div
        class="alert"
        :class="result.status === 'success' ? 'alert-success' : 'alert-danger'"
      >
        {{ result.message }}
      </div>

      <!-- ✅ Liste des détails -->
      <ul class="list-group mt-2" v-if="result.data && result.data.length">
        <li
          class="list-group-item"
          v-for="(item, index) in result.data"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    result() {
      return this.$store.getters["backup/getResult"];
    },
  },
  methods: {
    runBackup() {
      this.$store.dispatch("backup/run");
    },
  },
};
</script>
